/**
@prop --ux-input-label-color: text color of the label
@prop --ux-input-label-font-size: font-size of the label
@prop --ux-input-label-font-weight: font-weight of the label
@prop --ux-input-label-line-height: line-height of the label
@prop --ux-input-label-padding: inner padding of the label
@prop --ux-input-label-margin: outer margin of the label
@prop --ux-input-label-spacing: gap size between label elements
@prop --ux-input-label-text-transform: text-transform of the label
@prop --ux-input-label-required-symbol: symbol that is displayed after the label text if required is `true`
 */
.ux-input-label {
  display: block;
}

ux-input-label .ux-label {
  box-sizing: border-box;
  display: block;
  font-family: var(--ux-font);
  font-size: var(--ux-input-label-font-size, var(--ux-label-font-size));
  font-weight: var(--ux-input-label-font-weight, var(--ux-label-font-weight));
  line-height: var(--ux-input-label-line-height, var(--ux-label-line-height));
  margin: var(--ux-input-label-margin, var(--ux-label-margin));
  padding: var(--ux-input-label-padding, var(--ux-label-padding));
  text-transform: var(--ux-input-label-text-transform, var(--ux-label-text-transform));

  .ux-label__text,
  .ux-label__label-slot,
  .ux-label__error-msg,
  .ux-label__info,
  > * {
    display: inline;
    vertical-align: top;
  }

  /* stylelint-disable selector-max-compound-selectors */
  .ux-label__text + * {
    margin-left: var(--ux-input-label-spacing, var(--ux-label-spacing));
  }
  /* stylelint-enable selector-max-compound-selectors */

  &--required {
    .ux-label__text::after {
      content: var(--ux-input-label-required-symbol);
    }
  }

  &--empty {
    padding: var(--ux-input-label-padding-empty);
  }
}
